import posthog from 'posthog-js';

const reportWebVitals = (onPerfEntry) => {
  // Check if performance tracking is enabled
  const enablePerformanceTracking = localStorage.getItem('enablePerformanceTracking');
  const isEnabled = enablePerformanceTracking === null || JSON.parse(enablePerformanceTracking) === true;
  
  if (!isEnabled) {
    return; // Silently skip if tracking is disabled
  }
  
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      // Wrapper function to format and log metrics
      const logMetric = (metric) => {
        console.group(`📊 Web Vitals: ${metric.name}`);
        console.log(`Value: ${metric.value.toFixed(2)} ${metric.name === 'CLS' ? '' : 'ms'}`);
        console.log(`Rating: ${metric.rating}`);
        console.log(`Delta: ${metric.delta.toFixed(2)}`);
        console.log(`ID: ${metric.id}`);
        console.log(`Navigation Type: ${metric.navigationType}`);
        if (metric.entries && metric.entries.length > 0) {
          console.log(`Entries:`, metric.entries);
        }
        console.groupEnd();
        
        // Send to PostHog using official SDK
        if (posthog.__loaded) {
          posthog.capture('$web_vitals', {
            $web_vitals_metric: metric.name,
            $web_vitals_value: metric.value,
            $web_vitals_delta: metric.delta,
            $web_vitals_rating: metric.rating,
            $web_vitals_id: metric.id,
            $web_vitals_navigation_type: metric.navigationType,
          });
        }
        
        // Also call the original callback if needed
        if (onPerfEntry !== console.log) {
          onPerfEntry(metric);
        }
      };

      onCLS(logMetric);
      onINP(logMetric);
      onFCP(logMetric);
      onLCP(logMetric);
      onTTFB(logMetric);
    });
  }
};

// Export function to manually trigger Web Vitals reporting on navigation
export const reportNavigationVitals = () => {
  // Check if performance tracking is enabled
  const enablePerformanceTracking = localStorage.getItem('enablePerformanceTracking');
  const isEnabled = enablePerformanceTracking === null || JSON.parse(enablePerformanceTracking) === true;
  
  if (!isEnabled) {
    return; // Silently skip if tracking is disabled
  }
  
  import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
    const logMetric = (metric) => {
      console.group(`🔗 Navigation Web Vitals: ${metric.name}`);
      console.log(`Path: ${window.location.pathname}`);
      console.log(`Value: ${metric.value.toFixed(2)} ${metric.name === 'CLS' ? '' : 'ms'}`);
      console.log(`Rating: ${metric.rating}`);
      console.log(`Delta: ${metric.delta.toFixed(2)}`);
      console.groupEnd();

      // Send to PostHog using official SDK
      if (posthog.__loaded) {
        posthog.capture('$web_vitals', {
          $web_vitals_metric: metric.name,
          $web_vitals_value: metric.value,
          $web_vitals_delta: metric.delta,
          $web_vitals_rating: metric.rating,
          $web_vitals_id: metric.id,
          $web_vitals_navigation_type: 'spa-navigation',
        });
      }
    };

    // Report current metrics
    onCLS(logMetric, { reportAllChanges: true });
    onINP(logMetric, { reportAllChanges: true });
    onFCP(logMetric, { reportAllChanges: true });
    onLCP(logMetric, { reportAllChanges: true });
    onTTFB(logMetric, { reportAllChanges: true });
  });
};

export default reportWebVitals;
